<div [class.my-app-dark]="isDarkMode()">
  <p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'300ms'"
    [hideTransitionOptions]="'400ms'" [showTransformOptions]="'translateX(100%)'" />
  <router-outlet />
</div>